<template>
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <span class="ml20">公共物模型</span>
          <!-- 已经发布 publish_status === 1   未发布 publish_status != 1 -->
          <!-- <v-button
            class="flr"
            type="primary"
            name="showPublish"
            @click="showPublishModel()"
            >{{ "发布物模型" }}</v-button
          > -->
        </div>
      </div>
      <div class="main-center">
        <!-- <v-button class="" type="info" name="" @click="showModel"
          >物模型TSL</v-button
        > -->
        <div style="display: flex; justify-content: space-between;">
          <div class="left">
            <v-button class="" type="primary" name="" @click="showAddModel">
              添加公共物模型
            </v-button>
          </div>
          <div class="right">
            <v-select
              v-model="ruleForm.functionType"
              :options="functionTypeOptions"
              class="mr10"
              placeholder="请选择功能类型"
              @change="getData"
            >
            </v-select>
            <v-input
              v-model="ruleForm.name"
              placeholder="请输入功能名称"
              suffix-icon="v-icon-search"
              class="mr10"
              @change="getData"
            >
            </v-input>
            <v-input
              v-model="ruleForm.identifier"
              placeholder="请输入标识符"
              suffix-icon="v-icon-search"
              @change="getData"
            >
            </v-input>
          </div>
        </div>
      </div>
      <vxe-table
        row-id="id"
        :data="infoData"
        align="left"
        :sort-config="{
          defaultSort: { field: 'function_typeView', order: 'asc' },
        }"
      >
        <vxe-table-column
          field="name"
          show-overflow
          min-width="80"
          title="功能名称"
        ></vxe-table-column>
        <!-- <vxe-table-column
          sortable
          field="function_typeView"
          show-overflow
          min-width="80"
          title="功能类型"
        ></vxe-table-column> -->

        <vxe-column title="功能类型" field="function_typeView" sortable show-overflow min-width="80">
          <template v-slot="slotProps">
            <span v-if="slotProps.row.function_typeView === '事件'" class="text-success" >{{slotProps.row.function_typeView}}</span>
            <span v-if="slotProps.row.function_typeView === '属性'" class="text-error" >{{slotProps.row.function_typeView}}</span>
            <span v-if="slotProps.row.function_typeView === '服务'" class="text-warn" >{{slotProps.row.function_typeView}}</span>
          </template>
        </vxe-column>


        <vxe-table-column
          field="identifier"
          show-overflow
          min-width="100"
          title="功能唯一标识"
        ></vxe-table-column>
        <vxe-table-column
          field="data_type"
          show-overflow
          min-width="80"
          title="数据类型"
        ></vxe-table-column>
        <vxe-table-column
          field="desc"
          show-overflow
          min-width="280"
          title="备注"
        ></vxe-table-column>
        <vxe-column title="操作" min-width="140">
          <template v-slot="slotProps">
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn2"
                slot="reference"
                @click="openViewModel(slotProps.row, 1)"
                >编辑</v-button
              ></span
            >
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn2"
                slot="reference"
                @click="openDelModel(slotProps.row)"
                >删除</v-button
              ></span
            >
          </template>
        </vxe-column>
      </vxe-table>
    </div>

    <v-pagination
      v-if="total"
      @change-page="changePage"
      @change-size="changeSize"
      :total="total"
      name="page-basic"
      is-show-total
      is-change-size
      is-input-page
      :current-page="this.currentPage"
    ></v-pagination>

    <AddPhysicalmodel
      :showInputDialog.sync="addloading"
      ref="add"
      :productId="productId"
      :productKey="productKey"
      @getData="getData"
    ></AddPhysicalmodel>
    <UpdataAndview
      :showInputDialog.sync="UpdataAndviewloading"
      ref="UpdataAndview"
      :updataOrview="updataOrview"
      :id="id"
      :functiontype="functiontype"
      @getData="getData"
    ></UpdataAndview>
    <Del
      :showInputDialog.sync="Delloading"
      ref="del"
      :id="id"
      @getData="getData"
    ></Del>
  </div>
</template>

<script>
import AddPhysicalmodel from "@/components/common-physical-model/add-physicalmodel.vue";
import UpdataAndview from "@/components/common-physical-model/updataAndview-physicalmodel.vue";
import Del from "@/components/common-physical-model/del.vue";
import { FUNCTION_TYPE } from "@/common/libs/Contains";
export default {
  components: { AddPhysicalmodel, UpdataAndview, Del },
  props: {},
  data() {
    return {
      table: [],
      addloading: false,
      UpdataAndviewloading: false,
      Delloading: false,
      updataOrview: 1, //1为编辑 2为查看
      id: 0,
      functiontype: "",
      infoData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      productName: "",
      productKey: "",
      ruleForm: {
        functionType: "",
        identifier: "",
        name: "",
      },
      functionTypeOptions: [
        {
          label: "全部",
          value: "all",
        },
        {
          label: "属性",
          value: "properties",
        },
        {
          label: "服务",
          value: "service",
        },
        {
          label: "事件",
          value: "event",
        },
      ],
    };
  },
  created() {
    this.productName = this.$route.query.productName;
    this.productKey = this.$route.query.productKey;
    this.productId = this.$route.query.productId;
    this.getData();
  },

  methods: {
    async getData() {
      const subData = {
        function_type:
          this.ruleForm.functionType === "all"
            ? ""
            : this.ruleForm.functionType,
        name: this.ruleForm.name,
        identifier: this.ruleForm.identifier,
        page_num: this.currentPage,
        page_size: this.pageSize,
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/thing/common/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.infoData = res.data.list;
        this.total = res.data.page.total;
        this.infoData.map((item) => {
          item.function_typeView = FUNCTION_TYPE[item.function_type];
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1;
      this.getData();
    },
    openViewModel(row, isUpdata) {
      this.updataOrview = isUpdata;
      this.id = row.ID;
      this.functiontype = row.function_type;
      this.UpdataAndviewloading = !this.UpdataAndviewloading;
    },
    showAddModel() {
      this.addloading = !this.addloading;
    },
    openDelModel(row) {
      this.id = row.ID;
      this.Delloading = !this.Delloading;
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>

